import {
  SYSTEM_INDUSTRYTYPE_MODAL_CHANGE,
} from './constants';

export function industryTypeModalChange(visible,type) {
  return {
    type: SYSTEM_INDUSTRYTYPE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_INDUSTRYTYPE_MODAL_CHANGE:
      return {
        ...state,
        industryTypeModalType:action.data.type,
        industryTypeModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/industryTypeModalChange.js